/*@flow*/

// Returns a function that will be called after N milliseconds.
//
// Throttling will delay executing a function.
// see: https://stackoverflow.com/a/25991510/32816
//
// threshhold: 10
// Input Stream:  |---1---2--3--------------->
// Output Stream: |---1----------------3----->
//
export default function throttle(
  fn: Function,
  threshhold: number = 250,
  scope: any
): ((...args: Array<any>) => void) {
  let last;
  let deferTimer;

  return (...args: any[]) => {
    let context = scope || this;

    let now = +new Date();

    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

export const th = (wait: number): ((fn: any) => (...args: Array<any>) => void) => (fn: Function) => throttle(fn, wait);
